import { FC } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { CareMapState } from '../../caremap/CareMapState';
import { SharingAndAccessSheet } from './SharingAndAccessSheet';
import { SharingAndAccessState } from './SharingAndAccessState';

// Single app-level mount of the Sharing & Access sheet, opened from anywhere (the care
// recipient menu, the community Manage button, a member's access banner) via the shared
// SharingAndAccessState. Rendered only when a care map is active — the sheet reads the
// active care map's community, which throws when there isn't one.
export const GlobalSharingAndAccessSheet: FC = () => {
    const state = useInstance(SharingAndAccessState);
    useSubscription(() => state);

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    if (!careMapState.getActiveCaremap()) {
        return null;
    }

    return <SharingAndAccessSheet isOpen={state.isOpen} initialPage={state.startOnAddPerson ? 'add-person' : 'list'} onDidDismiss={state.close} />;
};
